import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { getCompanyContracts } from '../../services/NewServicesCompnay'
import { isContractFullySigned } from '../../utils/companyOnboarding'
import Loader from '../Loader'
import {
  ContractDocumentNav,
  ContractDocumentViewer,
} from '../ContractDocumentViewer/ContractDocumentViewer'

const FULL_VIEWER_HEIGHT = 'calc(100vh - 168px)'

const ContractMetaBar = ({ contract }) => {
  if (!contract) return null
  console.log('contract', contract)
  const sig = contract.contract_signature ?? {}
  const status = contract.contract_signature?.contract_signature_status?.name ?? '—'
  const startDate = contract.start_date
    ? dayjs(contract.start_date).format('DD/MM/YYYY')
    : '—'
  const endDate = contract.end_date
    ? dayjs(contract.end_date).format('DD/MM/YYYY')
    : '—'
  const isSigned = isContractFullySigned(contract)
  const signedAt = isSigned
    ? dayjs(sig.signed_at ?? sig.updated_at).format('DD/MM/YYYY')
    : null

  return (
    <div
      className="d-flex flex-wrap gap-3 py-2 px-3 rounded mb-2"
      style={{
        background: '#f9fafb',
        border: '1px solid #f3f4f6',
        fontSize: 12,
      }}
    >
      <div>
        <span style={{ color: '#9ca3af', marginRight: 4 }}>Estado:</span>
        <span style={{ fontWeight: 600, color: '#111827' }}>{status}</span>
      </div>
      <div>
        <span style={{ color: '#9ca3af', marginRight: 4 }}>Vigencia:</span>
        <span style={{ fontWeight: 600, color: '#111827' }}>
          {startDate} — {endDate}
        </span>
      </div>
      <div>
        <span style={{ color: '#9ca3af', marginRight: 4 }}>Monto:</span>
        <span style={{ fontWeight: 600, color: '#111827' }}>
          ${contract.company_final_amount ?? '—'}
          {contract.company_tax_applies
            ? ` (IVA ${contract.company_tax_percent ?? '—'}%)`
            : ''}
        </span>
      </div>
      {signedAt && (
        <div>
          <span style={{ color: '#9ca3af', marginRight: 4 }}>Firmado:</span>
          <span style={{ fontWeight: 600, color: '#166534' }}>{signedAt}</span>
        </div>
      )}
    </div>
  )
}

const ContractPreviewSection = ({
  finalPdfUrl: finalPdfUrlProp = null,
  initialDocxUrl: initialDocxUrlProp = null,
  contractStatus: contractStatusProp = null,
  contract: contractProp = null,
  contractsTotal: contractsTotalProp,
  contractsCurrent: contractsCurrentProp,
  onContractChange: onContractChangeProp,
  fetchContracts = false,
  viewerHeight = FULL_VIEWER_HEIGHT,
}) => {
  const [internalIndex, setInternalIndex] = useState(0)

  const { data: contractsData, isLoading } = useQuery({
    queryKey: ['company-contracts', 0],
    queryFn: () => getCompanyContracts(0),
    enabled: fetchContracts,
  })

  const contracts = contractsData?.res?.list ?? []
  const useInternalNav = fetchContracts && contractsTotalProp == null

  const currentIndex = useInternalNav
    ? internalIndex
    : contractsCurrentProp ?? 0

  const handleIndexChange = (next) => {
    if (useInternalNav) {
      setInternalIndex(next)
      return
    }
    onContractChangeProp?.(next)
  }

  const currentContract =
    contractProp ?? (fetchContracts ? contracts[currentIndex] ?? null : null)
  const sig = currentContract?.contract_signature ?? {}

  console.log('currentContract', currentContract)

  const finalPdfUrl = finalPdfUrlProp ?? sig.final_pdf_url ?? null
  const initialDocxUrl = initialDocxUrlProp ?? sig.initial_pdf_url ?? null
  const contractStatus =
    contractStatusProp ?? currentContract?.contract_status?.name ?? null
  const contractsTotal = contractsTotalProp ?? contracts.length

  if (fetchContracts && isLoading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Loader />
      </div>
    )
  }

  if (fetchContracts && !contracts.length) {
    return <></>
  }

  return (
    <div
      className="w-100"
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        overflow: 'hidden',
        background: '#fff',
      }}
    >
      <div
        className="px-3 px-lg-4 pt-3 pb-2"
        style={{ borderBottom: '1px solid #f3f4f6' }}
      >
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
          <p
            className="mb-0"
            style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}
          >
            Contrato
          </p>
          {contractStatus && (
            <span
              className="rounded-pill px-3 py-1"
              style={{
                background: '#f3f4f6',
                color: '#374151',
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {currentContract?.contract_signature?.contract_signature_status?.name ?? '—'}
            </span>
          )}
        </div>

        <ContractMetaBar contract={currentContract} />

        <ContractDocumentNav
          total={contractsTotal}
          current={currentIndex}
          onChange={handleIndexChange}
        />
      </div>

      <ContractDocumentViewer
        finalPdfUrl={finalPdfUrl}
        initialDocxUrl={initialDocxUrl}
        height={viewerHeight}
      />
    </div>
  )
}

export default ContractPreviewSection
